import { render, staticRenderFns } from "./HrAndDistribution.vue?vue&type=template&id=1ebc388e&scoped=true&"
import script from "./HrAndDistribution.vue?vue&type=script&lang=js&"
export * from "./HrAndDistribution.vue?vue&type=script&lang=js&"
import style0 from "./HrAndDistribution.vue?vue&type=style&index=0&id=1ebc388e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc388e",
  null
  
)

export default component.exports